'use strict'

const DEM_PROVIDER_OPENHIKING_HUNGARY = 'openhikingHungary'
const DEM_PROVIDER_OE = 'oeDEM'
const DEM_PROVIDER_G = 'gDEM'
const DEM_PROVIDER_OTD = 'otdDEM'
const DEM_PROVIDER_OME = 'omeDEM'
const DEM_PROVIDER_ARCGIS_ELE = 'arcgisEle'

const DEFAULT_MAP_CURSOR_ELEVATION_PROVIDER = DEM_PROVIDER_OPENHIKING_HUNGARY
const DEFAULT_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER = DEM_PROVIDER_OPENHIKING_HUNGARY

const MAP_CURSOR_ELEVATION_CACHE_MAX = 500
const MAP_CURSOR_ELEVATION_COORD_DECIMALS = 4
const MAP_CURSOR_ELEVATION_MIN_REQUEST_INTERVAL_MS = 250

const DEM_PROVIDER_CONFIG = {
  openhikingHungary: {
    enabled: true,
    label: 'OpenHiking Hungary',
    accuracy: 'offline',
    batchSize: 25
  },
  oeDEM: {
    enabled: true,
    label: 'Open-Elevation',
    accuracy: '~30-90 m',
    batchSize: 50
  },
  gDEM: {
    enabled: true,
    label: 'Google Elevation',
    accuracy: '~30 m',
    batchSize: 200
  },
  otdDEM: {
    enabled: true,
    label: 'OpenTopoData',
    accuracy: '~90 m',
    batchSize: 50
  },
  omeDEM: {
    enabled: true,
    label: 'Open-Meteo',
    accuracy: '~90 m',
    batchSize: 100
  },
  arcgisEle: {
    enabled: false,
    label: 'ArcGIS-Ele (WorldElevation3D)',
    accuracy: '~10-90 m',
    batchSize: 100
  }
}

const DEM_PROVIDER_ALL = [
  DEM_PROVIDER_OPENHIKING_HUNGARY,
  DEM_PROVIDER_G,
  DEM_PROVIDER_OME,
  DEM_PROVIDER_OE,
  DEM_PROVIDER_OTD,
  DEM_PROVIDER_ARCGIS_ELE
]

const isDemProviderEnabledFromConfig = function (providerKey, config = DEM_PROVIDER_CONFIG) {
  const cfg = config[String(providerKey || '').trim()]
  if (!cfg) return false
  return cfg.enabled !== false
}

const buildEnabledDemProviderPriority = function (config = DEM_PROVIDER_CONFIG) {
  return DEM_PROVIDER_ALL.filter(function (providerKey) {
    return isDemProviderEnabledFromConfig(providerKey, config)
  })
}

const buildCursorDemProviderPriority = function (config = DEM_PROVIDER_CONFIG) {
  const preferredOrder = [
    DEM_PROVIDER_OPENHIKING_HUNGARY,
    DEM_PROVIDER_G,
    DEM_PROVIDER_ARCGIS_ELE,
    DEM_PROVIDER_OME
  ]
  const enabled = buildEnabledDemProviderPriority(config)
  return preferredOrder
    .filter(function (providerKey) {
      return isDemProviderEnabledFromConfig(providerKey, config)
    })
    .concat(enabled.filter(function (providerKey) {
      return !preferredOrder.includes(providerKey)
    }))
}

const DEM_PROVIDER_PRIORITY = buildEnabledDemProviderPriority()
const DEM_CURSOR_PROVIDER_PRIORITY = buildCursorDemProviderPriority()

export {
  DEM_PROVIDER_OPENHIKING_HUNGARY,
  DEM_PROVIDER_OE,
  DEM_PROVIDER_G,
  DEM_PROVIDER_OTD,
  DEM_PROVIDER_OME,
  DEM_PROVIDER_ARCGIS_ELE,
  DEFAULT_MAP_CURSOR_ELEVATION_PROVIDER,
  DEFAULT_MAP_CURSOR_ELEVATION_FALLBACK_PROVIDER,
  MAP_CURSOR_ELEVATION_CACHE_MAX,
  MAP_CURSOR_ELEVATION_COORD_DECIMALS,
  MAP_CURSOR_ELEVATION_MIN_REQUEST_INTERVAL_MS,
  DEM_PROVIDER_CONFIG,
  DEM_PROVIDER_ALL,
  DEM_PROVIDER_PRIORITY,
  DEM_CURSOR_PROVIDER_PRIORITY,
  isDemProviderEnabledFromConfig,
  buildEnabledDemProviderPriority,
  buildCursorDemProviderPriority
}
